import { register } from '../../../Utils'

const Accordion = el => {
  const expandFirst = el.getAttribute('data-expandFirst')
  const accordionPanels = el.querySelectorAll('[data-accordion-panel]')
  if (expandFirst === '1') {
    accordionPanels[0].setAttribute('data-is-active', '')
  }

  accordionPanels.forEach((_, index) => {
    const panel = accordionPanels[index]
    panel.addEventListener('click', () => {
      const isActive = panel.hasAttribute('data-is-active')

      accordionPanels.forEach(el => {
        if (el.hasAttribute('data-is-active')) {
          el.removeAttribute('data-is-active')
        }
      })

      if (isActive) {
        panel.removeAttribute('data-is-active')
      } else {
        panel.setAttribute('data-is-active', '')
      }
    })
  })
}

register('Accordion', Accordion)
